import { Component, input } from '@angular/core';
import { EnergyValuePipe } from '@core';
import { PowerType } from '@devices/models';

import { EnergyIconComponent } from '../energy-icon';

@Component({
  imports: [EnergyValuePipe, EnergyIconComponent],
  selector: 'avs-energy-value',
  styleUrl: './energy-value.component.scss',
  templateUrl: './energy-value.component.html',
})
export class EnergyValueComponent {
  config = input.required<{
    showFullTitle: boolean,
    type: PowerType,
    value: number,
  }>();
  protected readonly ePowerType = PowerType;
}
